import _ from 'lodash';
import { checkAllLimits } from 'shared/helpers/purchase-limits';
import { productIncludedInType } from 'shared/helpers/check-limits/utils';

export const maxQuantity = (key, cart, isMedical, order) => {
  const { dispensary, customerState } = order;
  const { quantity, product } = cart[key];

  let currentMaxQuantity = quantity;

  let withinLimits = false;

  while (!withinLimits) {
    const limitsCheck = checkAllLimits({
      newItemId: key,
      itemBeingAdded: { ..._.clone(cart[key]), quantity: currentMaxQuantity },
      existingItems: cart,
      medical: isMedical,
      dispensary,
      changingQuantity: true,
      customerState,
      complianceOnly: true,
    });

    // Make sure we're not inadvertently removing products whose types
    // are still within the limits when switching from med -> rec
    const { typesOverLimit } = limitsCheck;
    let productExceedsLimits;

    if (typesOverLimit?.length > 0) {
      // eslint-disable-next-line max-len
      productExceedsLimits = _.some(typesOverLimit, (exceededType) =>
        productIncludedInType(product, exceededType, order)
      );
    }

    if (limitsCheck.withinLimits || !productExceedsLimits || currentMaxQuantity === 0) {
      withinLimits = true;
    } else {
      currentMaxQuantity -= 1;
    }
  }

  return currentMaxQuantity;
};
